<template>
  <b-container>
    <b-row>
      <b-col
        class="px-4 col-sm-12 col-md-8 col-lg-12 col-xl-12 offset-md-2 offset-lg-0 offset-xl-0 col-12"
        :class="notifications.length > 0 ? 'mt-3' : ''"
      >
        <notification-bar v-for="notification in notifications" :key="notification.id" :notification="notification" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from 'vuex';
import NotificationBar from './NotificationBar';

export default {
  name: 'NotificationContainer',
  components: {
    NotificationBar,
  },
  props: {
    onlyLicensingNotifications: {
      type: Boolean,
      default: false,
    },
    suppressedFamilies: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState('notification', { allNotifications: (state) => state.notifications }),
    notifications() {
      const visible = !this.onlyLicensingNotifications
        ? this.allNotifications
        : this.allNotifications?.filter((notification) => notification?.showInLicensing);

      return visible?.filter(
        (notification) => this.isProblemNotification(notification) || !this.suppressedFamilies.includes(notification?.family)
      );
    },
  },
  methods: {
    // The AddItem family carries both the basket count bar and the add-to-basket failure
    // notification. Suppressing by family alone leaves a failed add with no feedback at all.
    isProblemNotification(notification) {
      return ['danger', 'warning'].includes(notification?.type);
    },
  },
};
</script>

<style lang="scss" scoped></style>
